import { CREDITS } from "@card-data/credits";
import { schemas } from "@card-data/generated/api.client";

import { DISCONTINUED_OFFERS } from "../placeholder-offers";
import { CreditCardInput } from "../types";
import { WEIGHTS } from "../weights";

export const CITI_CARDS: Array<CreditCardInput> = [
  {
    cardId: "3543149f6555df6f7e4974923c55d853",
    name: "AAdvantage Executive",
    issuer: schemas.IssuersEnum.enum.CITI,
    network: schemas.NetworksEnum.enum.MASTERCARD,
    currency: schemas.CurrenciesEnum.enum.AMERICAN,
    isBusiness: false,
    annualFee: 695,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://creditcards.aa.com/citi-executive-card-american-airlines-direct/",
    imageUrl: "/images/citi/aadvantage-executive.webp",
    credits: [],
    offers: [
      {
        amount: [{ amount: 125_000 }],
        spend: 15_000,
        days: 150,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 100_000 }],
        spend: 10_000,
        days: 90,
        credits: [],
        expiration: "2026-08-24",
      },
      {
        amount: [{ amount: 70_000 }],
        spend: 7000,
        days: 90,
        credits: [],
        expiration: "2023-10-01",
      },
    ],
  },
  {
    cardId: "196b33e005dd1bc8e1c505f2bf98a1d1",
    name: "AAdvantage MileUp",
    issuer: schemas.IssuersEnum.enum.CITI,
    network: schemas.NetworksEnum.enum.MASTERCARD,
    currency: schemas.CurrenciesEnum.enum.AMERICAN,
    isBusiness: false,
    annualFee: 0,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://creditcards.aa.com/citi-mileup-card-american-airlines-direct/",
    imageUrl: "/images/citi/aadvantage-mileup.webp",
    credits: [],
    offers: [
      {
        amount: [{ amount: 15_000 }],
        spend: 500,
        days: 90,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 15_000 }],
        spend: 500,
        days: 90,
        credits: [],
      },
    ],
  },
  {
    cardId: "a497d6ba509538db9e3e4a3e5e313fe9",
    name: "AAdvantage Platinum Select World Elite",
    issuer: schemas.IssuersEnum.enum.CITI,
    network: schemas.NetworksEnum.enum.MASTERCARD,
    currency: schemas.CurrenciesEnum.enum.AMERICAN,
    isBusiness: false,
    annualFee: 99,
    isAnnualFeeWaived: true,
    universalCashbackPercent: 1,
    url: "https://creditcards.aa.com/credit-cards/citi-platinum-card-american-airlines-direct/",
    imageUrl: "/images/citi/aadvantage-platinum-select.webp",
    credits: [],
    offers: [
      {
        amount: [{ amount: 80_000 }],
        spend: 3500,
        days: 120,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 80_000 }],
        spend: 3500,
        days: 120,
        credits: [],
        expiration: "2025-09-29",
      },
      {
        amount: [{ amount: 125_000 }],
        spend: 5000,
        days: 90,
        credits: [],
        expiration: "2024-03-01",
      },
    ],
  },
  {
    cardId: "c6b04cf07dd821ddcfba3dbe398a4b31",
    name: "AAdvantage Globe",
    issuer: schemas.IssuersEnum.enum.CITI,
    network: schemas.NetworksEnum.enum.MASTERCARD,
    currency: schemas.CurrenciesEnum.enum.AMERICAN,
    isBusiness: false,
    annualFee: 350,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://creditcards.aa.com/credit-cards/citi-globe-card-american-airlines-direct/",
    imageUrl: "/images/citi/aadvantage-globe.webp",
    credits: [
      {
        value: 300,
        weight: WEIGHTS.LOUNGES,
        description: "Lounge Access",
      },
      {
        value: 100,
        weight: WEIGHTS.TRAVEL_CREDIT_FUNGIBLE,
        description: "'Splurge' Credit",
      },
      {
        value: 240,
        weight: WEIGHTS.TURO,
        description: "Turo Credit",
      },
      {
        value: 100,
        weight: WEIGHTS.AIRLINE_FEE_CREDIT,
        description: "In-Flight Purchase Credit",
      },
    ],
    offers: [
      {
        amount: [{ amount: 60_000 }],
        spend: 4000,
        days: 90,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 90_000 }],
        spend: 5000,
        days: 120,
        credits: [],
        expiration: "2026-07-16",
      },
    ],
  },
  {
    cardId: "f6ff3383cc6c52a81eb4715eb8d5de03",
    name: "AAdvantage Business World Elite",
    issuer: schemas.IssuersEnum.enum.CITI,
    network: schemas.NetworksEnum.enum.MASTERCARD,
    currency: schemas.CurrenciesEnum.enum.AMERICAN,
    isBusiness: true,
    annualFee: 99,
    isAnnualFeeWaived: true,
    universalCashbackPercent: 1,
    url: "https://creditcards.aa.com/credit-cards/citi-business-card-american-airlines-direct/",
    imageUrl: "/images/citi/aadvantage-platinum-select-business.webp",
    credits: [
      {
        value: 50,
        description: "First checked bag free",
        weight: 0.5,
      },
    ],
    offers: [
      {
        amount: [{ amount: 75_000 }],
        spend: 5000,
        days: 150,
        credits: [],
      },
      {
        amount: [{ amount: 65_000 }],
        spend: 4000,
        days: 120,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 75_000 }],
        spend: 4000,
        days: 120,
        credits: [],
        expiration: "2026-10-31",
      },
      {
        amount: [{ amount: 65_000 }],
        spend: 4000,
        days: 120,
        credits: [],
        expiration: "2026-04-04",
      },
    ],
  },
  {
    cardId: "06b9a384d710e73db7f0ded7613c9c4b",
    name: "Double Cash",
    issuer: schemas.IssuersEnum.enum.CITI,
    network: schemas.NetworksEnum.enum.MASTERCARD,
    currency: schemas.CurrenciesEnum.enum.USD,
    isBusiness: false,
    annualFee: 0,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 2,
    url: "https://www.citi.com/credit-cards/citi-double-cash-credit-card",
    imageUrl: "/images/citi/double-cash.png",
    credits: [],
    offers: [
      {
        amount: [{ amount: 200 }],
        spend: 1500,
        days: 180,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 200 }],
        spend: 1500,
        days: 180,
        credits: [],
      },
      {
        amount: [{ amount: 300 }],
        spend: 750,
        days: 180,
        credits: [],
      },
    ],
  },
  {
    cardId: "49fe6c73c0e823a89346979f50d5b981",
    name: "Custom Cash",
    issuer: schemas.IssuersEnum.enum.CITI,
    network: schemas.NetworksEnum.enum.MASTERCARD,
    currency: schemas.CurrenciesEnum.enum.USD,
    isBusiness: false,
    annualFee: 0,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 2,
    url: "https://www.citi.com/credit-cards/citi-custom-cash-credit-card",
    imageUrl: "/images/citi/custom-cash.png",
    credits: [],
    discontinued: true,
    offers: DISCONTINUED_OFFERS,
    historicalOffers: DISCONTINUED_OFFERS,
  },
  {
    cardId: "19c94f90056968ebde2882f7bb0f1010",
    name: "Strata Elite",
    issuer: schemas.IssuersEnum.enum.CITI,
    network: schemas.NetworksEnum.enum.MASTERCARD,
    currency: schemas.CurrenciesEnum.enum.CITI,
    isBusiness: false,
    annualFee: 595,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1.5,
    url: "https://www.citi.com/credit-cards/citi-strata-elite-credit-card",
    imageUrl: "/images/citi/strata-elite.webp",
    credits: [
      CREDITS.PRECHECK_OR_SIMILAR,
      {
        value: 469,
        description: "Lounge Access",
        weight: WEIGHTS.LOUNGES,
      },
      {
        value: 150, // dunno, ballpark
        description: "American Airlines Lounge Access",
        weight: WEIGHTS.LOUNGES,
      },
      {
        value: 300,
        description: "Hotel Credit",
        weight: WEIGHTS.TRAVEL_CREDIT_FUNGIBLE,
      },
      {
        value: 200,
        description:
          '"Splurge" Credit (1stDibs, American Airlines, Best Buy, Future Personal Training, Live Nation)',
        weight: 0.3, // american airlines and live nation are nice but otherwise these are meh
      },
      {
        value: 200,
        description: "Blacklane Credit",
        weight: 0.2, // pretty niche service
      },
    ],
    offers: [
      {
        amount: [{ amount: 75_000 }],
        spend: 6000,
        days: 90,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 75_000 }],
        spend: 4000,
        days: 90,
        credits: [],
      },
      {
        amount: [{ amount: 100_000 }],
        spend: 5000,
        days: 90,
        credits: [],
      },
    ],
  },
  {
    cardId: "d7e2e5b5e595ca6510c101349c914513",
    name: "Strata Premier",
    issuer: schemas.IssuersEnum.enum.CITI,
    network: schemas.NetworksEnum.enum.MASTERCARD,
    currency: schemas.CurrenciesEnum.enum.CITI,
    isBusiness: false,
    annualFee: 95,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 2,
    url: "https://www.citi.com/credit-cards/citi-strata-premier-credit-card",
    imageUrl: "/images/citi/strata-premier.png",
    details: "Cashback rate is 0.75cpp w/o Double Cash or Custom Cash.",
    credits: [
      {
        value: 100,
        description: "Hotel Credit ($500 min purchase)",
        weight: WEIGHTS.TRAVEL_CREDIT_FUNGIBLE,
      },
    ],
    offers: [
      {
        amount: [{ amount: 60_000 }],
        spend: 4000,
        days: 90,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 75_000 }],
        spend: 4000,
        days: 90,
        credits: [],
      },
    ],
  },
  {
    cardId: "cbc737da5cbd44575dec6325bbbd8688",
    name: "Strata",
    issuer: schemas.IssuersEnum.enum.CITI,
    network: schemas.NetworksEnum.enum.MASTERCARD,
    currency: schemas.CurrenciesEnum.enum.CITI,
    isBusiness: false,
    annualFee: 0,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 2,
    url: "https://www.citi.com/credit-cards/citi-strata-credit-card",
    imageUrl: "/images/citi/strata.webp",
    credits: [],
    offers: [
      {
        amount: [{ amount: 20_000 }],
        spend: 1000,
        credits: [],
        days: 90,
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 30_000 }],
        spend: 1000,
        credits: [],
        days: 90,
      },
    ],
  },
  {
    cardId: "d4bbd57e45d6a6ddb445ddec4e781d7c",
    name: "AT&T Points Plus",
    issuer: schemas.IssuersEnum.enum.CITI,
    network: schemas.NetworksEnum.enum.MASTERCARD,
    currency: schemas.CurrenciesEnum.enum.USD,
    isBusiness: false,
    annualFee: 0,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://www.att.com/deals/att-points-plus-citi/",
    imageUrl: "/images/citi/att-points-plus.jpg",
    credits: [],
    offers: [
      {
        amount: [{ amount: 250 }],
        spend: 500,
        days: 90,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 200 }],
        spend: 1000,
        days: 90,
        credits: [],
        expiration: "2026-04-20",
      },
      {
        amount: [{ amount: 100 }],
        spend: 1000,
        days: 90,
        credits: [],
      },
    ],
  },
  {
    cardId: "5fe8bf9df0f88d3dd13772292303f73e",
    name: "Costco Anywhere Visa",
    issuer: schemas.IssuersEnum.enum.CITI,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.USD,
    isBusiness: false,
    annualFee: 0,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://www.costco.com/anywhere-visa-signature-card.html",
    imageUrl: "/images/citi/costco-anywhere-visa.png",
    details:
      "Requires an active Costco membership. 5% back on Costco gas/EV charging, 4% other gas/EV (both up to $7k/yr combined, then 1%), 3% restaurants and eligible travel, 2% Costco/costco.com.",
    credits: [],
    offers: [
      // No welcome bonus — pure ongoing-cashback card, no spend-based offer to track.
    ],
    historicalOffers: [],
  },
];
